import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthTokenService } from '../services/auth-token/auth-token.service';
import { catchError, throwError } from 'rxjs';

export const jwttokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(AuthTokenService);
  const token = tokenService.getTokenFromLocal();

  if(req.url.match(/(loginmain|developerPanel|getSystemPrechecks|checkuserstatusLds|validate|getPassword|updateUserPassword)/gi)){
    return next(req);
  }

  let clonedReq = req;

  // If NOT FormData → set JSON Content-Type
  if (!(req.body instanceof FormData)) {
    clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8',
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        Pragma: 'no-cache',
        Expires: '0'
      }
    });

  } else {
    // FormData → DO NOT SET Content-Type (browser will set multipart boundary automatically)
    clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        Pragma: 'no-cache',
        Expires: '0'
      }
      // notice: no Content-Type here
    });
  }

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      return throwError(() => error);
    })
  );
};
